<template>
    <div class="home">
        <div class="notification is-warning" v-if="loading==true">Loading Sample Request ... </div>

        <div v-if="task_allowed('view_my_samples') && sample.completed == 0">
            <div class="button is-fullwidth is-success mb-5" v-if="sample.submitted==0 && sample.items.length > 0 && this.loading==false" :disabled="working==true" @click="submitRequest()">SUBMIT REQUEST</div>
            <div class="button is-fullwidth is-danger mb-5" v-if="sample.submitted==1 && sample.returned == 1 && sample.items.length > 0 && this.loading==false" :disabled="working==true" @click="resubmitRequest()">RETURN REQUEST</div>
        </div>
        
        <div class="box" v-if="loading==false">	
              
             <div class="tabs">
            <ul>
                <li ><a><strong>Request ID : {{ sample.id }}</strong></a></li>
                <li :class="{'is-active' : tabToView == 'details'}" @click="tabToView='details'"><a>Request Details</a></li>
                <li :class="{'is-active' : tabToView == 'attachments'}" @click="tabToView='attachments'"><a>Attachments <span v-if="sample != '' && sample.attachments.length>0">&nbsp;({{ sample.attachments.length }})</span></a></li>
                <li :class="{'is-active' : tabToView == 'items'}" @click="tabToView='items'"><a>Items/Garments <span v-if="sample != '' && sample.items.length>0">&nbsp;({{ sample.items.length }})</span></a></li>
                <li :class="{'is-active' : tabToView == 'notes'}" @click="tabToView='notes'"><a>Notes <span v-if="sample != '' &&  sample.notes.length>0">&nbsp;({{ sample.notes.length }})</span></a></li>
                <li :class="{'is-active' : tabToView == 'log'}" @click="tabToView='log'" style="display:none"><a>Log</a></li>
            </ul>
            </div>
            
            <div v-if="tabToView=='details'">
                
                <div class="field">
                          <label class="label">Requestor</label>
                          <div class="control">
                            <select class="input" v-model="sample.user_id"  required style="display:none">
                                <option value="">Please select ...</option>
                               <option :value="row.userID" v-for="row in users" :key="row.userID">{{ row.firstname}} {{  row.surname }}</option>
                               
                            </select>
                            {{  sample.firstname}} {{  sample.surname }}
                          </div>
                      </div>

                        <div class="field" >
                          <label class="label">Date Requested</label>
                          <div class="control">
                            {{ sample.date | formatUKDate}}
                             
                          </div>
                      </div>

                      <div class="field" v-if="sample.team_id > 0">
                          <label class="label">Team/Club Name </label>
                          <div class="control">
                            <select class="input" v-model="sample.team_id"  required >
                                <option value="">Please select ...</option>
                                <option :value="row.id" v-for="row in teams" :key="row.id">{{ row.name}}</option>
                               
                            </select>
                             
                          </div>
                      </div>

                      <div class="field" v-if="sample.club_name != ''">
                          <label class="label">Other Team/Club Name </label>
                          <div class="control">
                            <input class="input" type="text" v-model="sample.club_name" >
                             
                          </div>
                      </div>

                      <div class="field ">
                          <label class="label">Sample Type</label>
                          <div class="control select is-fullwidth">
                              <select class="input" v-model="sample.sample_type_id"  required >
                                <option value="">Please select ...</option>
                                <option :value="row.id" v-for="row in sample_types" :key="row.id">{{ row.name}}</option>
                               
                            </select>
                          </div>
                      </div>
      
                      <div class="field">
                          <label class="label">Is This A Follow Up To A Previous Request ? </label>
                          <div class="control">
                              <input class="input" type="text" v-model="sample.follow_up" placeholder="Enter previous request ID here"  >
                             
                          </div>
                      </div>
                     
                      <div class="field">
                          <label class="label">Potential Order Quantity </label>
                          <div class="control">
                              <input class="input" type="number" v-model="sample.quantity" min="1" step="1" required @keypress="isNumber($event)">
                             
                          </div>
                      </div>

                      <div class="field">
                          <label class="label">Generic Request Instructions</label>
                          <div class="control">
                              <textarea class="textarea"  v-model="sample.instructions"  ></textarea>
                                <small>You can add instructions for each item in the Items tab</small>
                          </div>
                      </div>

                      <div v-if="sample.processed == 1">
                        <div class="columns">
                            <div class="column">

                                <div class="field">
                                <label class="label">Print Location</label>
                                <div class="control">
                                    <div class="select">
                                    <select>
                                        <option>Select dropdown</option>
                                        <option selected>Strabane</option>
                                    </select>
                                    </div>
                                </div>
                                </div>

                            </div>
                             <div class="column">

                                <div class="field">
                                <label class="label">Cutting Location</label>
                                <div class="control">
                                    <div class="select">
                                    <select>
                                        <option>Select dropdown</option>
                                        <option selected>Strabane</option>
                                    </select>
                                    </div>
                                </div>
                                </div>

                            </div>
                            <div class="column">

                                <div class="field">
                                <label class="label">Makeup Location</label>
                                <div class="control">
                                    <div class="select">
                                    <select>
                                        <option>Select dropdown</option>
                                        <option selected>Giurgiu</option>
                                    </select>
                                    </div>
                                </div>
                                </div>

                            </div>

                        </div>
                      </div>
                </div>
                <!-- End of details tab -->
                     
                     
            
            <div v-if="tabToView=='attachments'">
                <h2 class="title is-size-5">Generic Request Attachments</h2>
                <table class="table is-fullwidth is-striped">
                    <thead>
                        <tr>
                            <th>Filename</th>
                            <th>Description</th>
                            <th>Date Added</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row) in sample.attachments" :key="row.id">
                            <td><A :href="ASP_SYSTEM_URL + '/uploads/samples/' + row.sample_id + '/' + row.filename" target="_blank">{{ row.filename }}</A></td>
                            <td>{{  row.description }}</td>
                             <td>{{  row.date_added | formatUKDate}}</td>
                        </tr>
                        
                    </tbody>
                </table>
                <hr />


                <h2 class="title is-size-5">Upload New Attachment</h2>

                <form @submit.prevent="submitFile">
                    <div class="field">
                        <div class="control">
                            <input ref="fileInput" class="input" type="file" placeholder="select file ..." @change="handleFileUpload">
                        </div>
                        </div>
                        <div class="field  ">
                                        <label class="label">Description</label>
                                        <div class="control  is-fullwidth">
                                            <input type="text"  class="input" v-model="file_description"   />
                                            
                                        </div>
                                    </div>
                        <div class="field is-grouped">
                            <div class="control">
                                <button class="button is-link" type="submit" :disabled="working==true">Submit</button>
                            </div>
                        
                        </div>
                </form>
            </div>
            <!-- end of attachments panel-->
        

         <div v-if="tabToView=='items'">
            <button class="button is-small is-pulled-right is-success" @click="addItem()">Add new Item</button>
            <h2 class="title is-size-5">Request Items</h2>
            <table class="table is-fullwidth is-striped">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Garment</th>
                        <th>Fabric</th>
                        <th>Type</th>
                        <th>Qty</th>
                        <th>Extras</th>
                        
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(row, index) in sample.items" >
                    <tr :key="'item' + row.id" style="font-weight:bold">
                        <td>{{  index+1 }}</td>
                        <td>{{ row.garmentname }}
                            <span v-if="row.garment_id==0"> {{ row.new_garment_name }}</span>
                            <button
                                class="button tag is-small is-info ml-2"
                                v-if="row.instructions && row.instructions.trim() !== ''"
                                type="button"
                                @click="openInstructionsModal(row)"
                            >Instructions</button>
                        </td>
                        <td>{{ row.fabric_name }}</td>
                        <td>{{ row.sample_item_type_name}}</td>
                        <td>{{ row.quantity}}</td>
                        <td >
                            <div class="tags">
                            <span class="tag " v-if="row.embroidery==1" :class="{'is-success' : row.embroidery_completed==1}">Embroidery</span>
                            <span class="tag " v-if="row.trims==1" :class="{'is-success' : row.trims_completed==1}">Trims</span>
                            <span class="tag " v-if="row.dtf==1" :class="{'is-success' : row.dtf_completed==1}">DTF</span>
                            <span class="tag " v-if="row.silicon==1" :class="{'is-success' : row.silicon_completed==1}">Silcon</span>
                            </div>
                        </td>
                       
                    </tr>
                    <tr :key="'artwork' + row.id">
                        <td></td>
                        <td >Artwork</td>
                        <td colspan="4" >
                            <div v-if="row.artwork_completed==1">
                             <span class="tag is-success is-small">✓ Complete</span> <button v-if="admin_user" class="button tag  is-small" :disabled="working==true" @click="unCompleteArea(row, 'artwork')">Undo Complete</button>
                            </div>
                            <div v-if="row.artwork_completed==0">
                             <span class="tag is-danger is-small">Not complete</span> <button v-if="admin_user" class="button tag is-small" :disabled="working==true" @click="completeArea(row, 'artwork')">Mark as Complete</button>
                            </div>
                        </td>
                        
                    </tr>
                    <tr :key="'digiprint' + row.id">
                        <td></td>
                        <td >Digital Print</td>
                         <td colspan="4" >
                            <div v-if="row.digital_print_completed==1">
                             <span class="tag is-success is-small">✓ Complete</span> <button v-if="admin_user" class="button tag  is-small" :disabled="working==true" @click="unCompleteArea(row, 'digital_print')">Undo Complete</button>
                            </div>
                            <div v-if="row.digital_print_completed==0">
                             <span class="tag is-danger is-small">Not complete</span> <button v-if="admin_user" class="button tag is-small" :disabled="working==true" @click="completeArea(row, 'digital_print')">Mark as Complete</button>
                            </div>
                        </td>
                    </tr>
                    <tr :key="'gerber' + row.id">
                        <td></td>
                        <td >Gerber Cutting</td>
                         <td colspan="4" >
                            <div v-if="row.gerber_cutting_completed==1">
                             <span class="tag is-success is-small">✓ Complete</span> <button v-if="admin_user" class="button tag  is-small" :disabled="working==true" @click="unCompleteArea(row, 'gerber_cutting')">Undo Complete</button>
                            </div>
                            <div v-if="row.gerber_cutting_completed==0">
                             <span class="tag is-danger is-small">Not complete</span> <button v-if="admin_user" class="button tag is-small" :disabled="working==true"  @click="completeArea(row, 'gerber_cutting')">Mark as Complete</button>
                            </div>
                        </td>
                    </tr>
                    <tr :key="'sundries' + row.id">
                        <td></td>
                        <td >Sundries</td>
                         <td colspan="4" >
                            <div v-if="row.sundries_completed==1">
                             <span class="tag is-success is-small">✓ Complete</span> <button v-if="admin_user" class="button tag  is-small" :disabled="working==true" @click="unCompleteArea(row, 'sundries')">Undo Complete</button>
                            </div>
                            <div v-if="row.sundries_completed==0">
                             <span class="tag is-danger is-small">Not complete</span> <button v-if="admin_user" class="button tag  is-small" :disabled="working==true" @click="completeArea(row, 'sundries')">Mark as Complete</button>
                            </div>
                        </td>
                    </tr>
                    <tr :key="'embroidery' + row.id" v-if="row.embroidery==1">
                        <td></td>
                        <td >Embroidery</td>
                         <td colspan="4" >
                            <div v-if="row.embroidery_completed==1">
                             <span class="tag is-success is-small">✓ Complete</span> <button v-if="admin_user" class="button tag  is-small" :disabled="working==true" @click="unCompleteArea(row, 'embroidery')">Undo Complete</button>
                            </div>
                            <div v-if="row.embroidery_completed==0">
                             <span class="tag is-danger is-small">Not complete</span> <button v-if="admin_user" class="button tag  is-small" :disabled="working==true" @click="completeArea(row, 'embroidery')">Mark as Complete</button>
                            </div>
                        </td>
                    </tr>
                    <tr :key="'trims' + row.id" v-if="row.trims==1">
                        <td></td>
                        <td >Trims</td>
                         <td colspan="4" >
                            <div v-if="row.trims_completed==1">
                             <span class="tag is-success is-small">✓ Complete</span> <button v-if="admin_user" class="button tag  is-small" :disabled="working==true" @click="unCompleteArea(row, 'trims')">Undo Complete</button>
                            </div>
                            <div v-if="row.trims_completed==0">
                             <span class="tag is-danger is-small">Not complete</span> <button v-if="admin_user" class="button tag  is-small" :disabled="working==true" @click="completeArea(row, 'trims')">Mark as Complete</button>
                            </div>
                        </td>
                    </tr>
                     <tr :key="'dtf' + row.id" v-if="row.dtf==1">
                        <td></td>
                        <td >DTF</td>
                         <td colspan="4" >
                            <div v-if="row.dtf_completed==1">
                             <span class="tag is-success is-small">✓ Complete</span> <button v-if="admin_user" class="button tag  is-small" :disabled="working==true" @click="unCompleteArea(row, 'dtf')">Undo Complete</button>
                            </div>
                            <div v-if="row.dtf_completed==0">
                             <span class="tag is-danger is-small">Not complete</span> <button v-if="admin_user" class="button tag  is-small" :disabled="working==true" @click="completeArea(row, 'dtf')">Mark as Complete</button>
                            </div>
                        </td>
                    </tr>
                    <tr :key="'silicon' + row.id" v-if="row.silicon==1">
                        <td></td>
                        <td >Silicon</td>
                         <td colspan="4" >
                            <div v-if="row.silicon_completed==1">
                             <span class="tag is-success is-small">✓ Complete</span> <button v-if="admin_user" class="button tag  is-small" :disabled="working==true" @click="unCompleteArea(row, 'silicon')">Undo Complete</button>
                            </div>
                            <div v-if="row.silicon_completed==0">
                             <span class="tag is-danger is-small">Not complete</span> <button v-if="admin_user" class="button tag  is-small" :disabled="working==true" @click="completeArea(row, 'silicon')">Mark as Complete</button>
                            </div>
                        </td>
                    </tr>
                    <tr :key="'makeup' + row.id">
                        <td></td>
                        <td >Makeup</td>
                         <td colspan="4" >
                            <div v-if="row.makeup_completed==1">
                             <span class="tag is-success is-small">✓ Complete</span> <button v-if="admin_user" class="button tag  is-small" :disabled="working==true" @click="unCompleteArea(row, 'makeup')">Undo Complete</button>
                            </div>
                            <div v-if="row.makeup_completed==0">
                             <span class="tag is-danger is-small">Not complete</span> <button v-if="admin_user" class="button tag  is-small" :disabled="working==true" @click="completeArea(row, 'makeup')">Mark as Complete</button>
                            </div>
                        </td>
                    </tr>
                    </template>
                    
                </tbody>
            </table>

                <div class="modal" v-bind:class="{ 'is-active' : showInstructionsModal }">
                    <div class="modal-background" @click="closeInstructionsModal()"></div>
                    <div class="modal-card">
                        <header class="modal-card-head">
                            <p class="modal-card-title">Item Instructions</p>
                            <button class="delete" aria-label="close" @click="closeInstructionsModal()"></button>
                        </header>
                        <section class="modal-card-body">
                            <p v-if="selectedInstructionItemName != ''" class="has-text-weight-semibold mb-3">{{ selectedInstructionItemName }}</p>
                            <div class="content">
                                <p style="white-space: pre-wrap;">{{ selectedItemInstructions }}</p>
                            </div>
                        </section>
                        <footer class="modal-card-foot">
                            <button class="button" type="button" @click="closeInstructionsModal()">Close</button>
                        </footer>
                    </div>
                </div>
         

                <div class="modal " v-bind:class="{ 'is-active' : showAddItemModal} ">
                    <div class="modal-background"></div>
                    <div class="modal-card process">
                        <header class="modal-card-head">
                        <p class="modal-card-title">Add New Item</p>
                        <button class="delete" aria-label="close" @click="showAddItemModal=false"></button>
                        </header>
                        <section class="modal-card-body">
                            <form @submit.prevent="saveSampleItem">
                            
                                    <div class="field " id="selectGarment">
                                        <label class="label">Garment</label>
                                         <div class="dropdown-trigger">
                                                    <input
                                                    class="input"
                                                    type="text"
                                                    placeholder="Search garments..."
                                                    v-model="garmentQuery"
                                                    @focus="active = true"
                                                    :disabled="garment_not_in_list"
                                                    >
                                                </div>
                                        
                                        <div class="control select is-fullwidth">
                                           
                                                        <select class="input" v-model="garment_id" :required="!garment_not_in_list" :disabled="garment_not_in_list" >
                                                <option value="">Please select ...</option>
                                            <option  v-for="row in filteredGarments" v-bind:key="row.id" :value="row.garmentID">{{ row.garmentname }}</option>
                                        
                                            </select>

                                            
                                        </div>
                                        <div class="field mt-2">
                                            <label class="checkbox">
                                                <input type="checkbox" v-model="garment_not_in_list" @change="toggleGarmentNotInList" />
                                                Garment is not in the list
                                            </label>
                                        </div>
                                        <div class="control is-fullwidth mt-2" v-if="garment_not_in_list">
                                            <input class="input" type="text" v-model="new_garment_name" :required="garment_not_in_list" placeholder="Enter new garment name" />
                                        </div>
                                    </div>
                                    <div class="field ">
                                        <label class="label">Fabric</label>
                                        <div class="control select is-fullwidth">
                                            <select class="input" v-model="fabric_id"   >
                                                <option value="">Please select ...</option>
                                            <option  v-for="row in fabrics" v-bind:key="row.id" :value="row.id">{{ row.name }}</option>
                                        
                                            </select>
                                        </div>
                                    </div>

                                
                                    <div class="field  ">
                                        <label class="label">Request Type</label>
                                        <div class="control select is-fullwidth">
                                            <select class="input" v-model="sample_item_type_id"  required >
                                                <option value="">Please select ...</option>
                                            <option :value="row.id" v-for="row in sample_item_types" :key="row.id">{{ row.name}}</option>
                                            
                                            </select>
                                        </div>
                                    </div>

                                    <div class="field  ">
                                        <label class="label">Number of Items</label>
                                        <div class="control  is-fullwidth">
                                            <input type="number" min="1" step="1" class="input" v-model="item_quantity"  required />
                                            
                                        </div>
                                    </div>
                    
                                    <div class="field  ">
                                        <label class="label">Extras</label>
                                        <div class="control tags ">
                                            <span class="button tag " :class="{'is-success' : item_embroidery == true}"  @click="item_embroidery = !item_embroidery">Embroidery</span>
                                            <span class="button tag " :class="{'is-success' : item_trims == true}"  @click="item_trims = !item_trims">Trims</span>
                                            <span class="button tag " :class="{'is-success' : item_dtf == true}"  @click="item_dtf = !item_dtf">DTF</span>
                                            <span class="button tag " :class="{'is-success' : item_silicon == true}"  @click="item_silicon = !item_silicon">Silicon</span>
                                        </div>
                                    </div>
                                    
                                
                                    <div class="field">
                                        <label class="label">Item Instructions</label>
                                        <div class="control">
                                            <textarea class="textarea"  v-model="item_instructions" required ></textarea>
                                            
                                        </div>
                                    </div>

                                    <div class="field" style="display:none">
                                        <label class="label">Item Attachments</label>
                                        <div class="control">
                                            <p><em>Derry 2024 Crest Logo.jpg</em></p>
                                            <p><em>Embroidery Photo Logo.png</em></p>
                                                <input type="file" />
                                        </div>
                                    </div>

                                    
                    
                                    <div class="field is-grouped mt-5">
                                        <div class="control">
                                            <button type="submit" class="button is-success" :disabled="working==true" >Save Item</button>
                                        </div>
                                    </div>
                                </form>
                        </section>
                    </div>
                </div>
                <!-- end of add item modal-->

         </div>
          <!-- end of items pabel -->
        

          <div v-if="tabToView=='notes'">
            <button class="button is-small is-pulled-right is-success" @click="addNote()">Add a Note</button>	
            <h3 class="title is-size-5">Notes</h3>
            <table class="table is-striped is-fullwidth">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>User</th>
                        <th>Note</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in sample.notes" :key="row.id">
                        <td>{{ row.date | formatUKDate }}</td>
                        <td>{{ row.user_firstname}} {{ row.user_surname}}</td>
                        <td>{{ row.note }}</td>
                    </tr>
                   

                </tbody>
            </table>
                <!-- Add Note model-->
                <div class="modal " v-bind:class="{ 'is-active' : showAddNoteModal} ">
                    <div class="modal-background"></div>
                    <div class="modal-card process">
                        <header class="modal-card-head">
                        <p class="modal-card-title">Add a Note</p>
                        <button class="delete" aria-label="close" @click="showAddNoteModal=false"></button>
                        </header>
                        <section class="modal-card-body">
                            <form @submit.prevent="saveSampleNote()">
                            
                                   
                                    <div class="field">
                                        <label class="label">Your Note</label>
                                        <div class="control">
                                            <textarea class="textarea"  v-model="note_text" required ></textarea>
                                        </div>
                                    </div>
                                    <div class="field" v-if="task_allowed('samples_production') && sample.returned==0 ">
                                        <label class="checkbox">
                                        <input type="checkbox" checked v-model="return_request" />
                                        Return sample to the requestor for more information
                                        </label>
                                        
                                    </div>

                                   
                                    <div class="field is-grouped mt-5">
                                        <div class="control">
                                            <button type="submit" class="button is-success" :disabled="working==true" >Save Note</button>
                                        </div>
                                    </div>
                                </form>
                        </section>
                    </div>
                </div>
                <!-- end of add note modal-->
          </div>
          <!-- end of notes tab-->
        </div>
        <!-- end of main box-->

            <div v-if="task_allowed('view_my_samples') && sample.completed == 0">
            <div class="button is-fullwidth is-success mb-5" v-if="sample.submitted==0 && sample.items.length > 0 && this.loading==false" :disabled="working==true" @click="submitRequest()">SUBMIT REQUEST</div>
            <div class="button is-fullwidth is-danger mb-5" v-if="sample.submitted==1 && sample.returned == 1 && sample.items.length > 0 && this.loading==false" :disabled="working==true" @click="resubmitRequest()">RETURN REQUEST</div>
            </div>


            <div class="box" v-if="admin_user==true">
                <h4 class="title is-size-5">Admin Tasks</h4>
                <div class="field" v-if="sample.completed == 0">
                    <label class="label">Mark Full Sample as Completed</label>
                    <div class="control">
                        <button class="button is-info" :disabled="working==true" @click="completeSample(sample)">Mark As Completed</button>
                    </div>
                </div>
                <div v-if="sample.completed==1" class="buttons">
                    <button class="button is-success" >Request Completed - {{  sample.completed_date | formatUKDate }}</button>
                    <button class="button is-danger" @click="unCompleteSample(sample)">Click to Re-Open Request</button>
                </div>
            </div> 
      </div>
  </template>

<script>
    import SampleService from '@/services/SampleService.js';
    import UtilityService from '@/services/UtilityService.js';
    import OrderMixin from "@/mixins/OrderMixin.js";

    export default {
      name: 'ViewSampleRequest',
      
        mixins: [OrderMixin],
        data: function () {
            return {
                   loading : false,
                  search: "",
                    API_NAME: process.env.VUE_APP_API_NAME,
                    ASP_SYSTEM_URL: process.env.VUE_APP_ASP_URL,
                    accessToken: '',
                    sample: [],
                    users: [],
                    user: {tasks: []},
                    sample_types: [],
                    sample_item_types: [],
                    showAddItemModal: false,
                    garments: [],
                    garment_id: '',
                    sample_item_type_id: '',
                    item_quantity: '',
                    item_instructions: '',
                    working:false,
                    item_silicon: false,
                    item_embroidery: false,
                    item_trims: false,
                    item_dtf: false,
                    file: null,
                    teams:[],
                    fabrics: [],
                    fabric_id: '',
                    tabToView:'details',
                    showAddNoteModal: false,
                    note_text: '',
                    garmentQuery: '',
                    include_hidden: 0,
                    return_request: false,
                    file_description: '',
                    garment_not_in_list: false,
                    new_garment_name: '',
                    showInstructionsModal: false,
                    selectedItemInstructions: '',
                    selectedInstructionItemName: '',
                   
                   
            }
        },
        created() {
          this.getAccessToken()
            .then(() => { 
               this.getSample();
               this.getTeams();
               this.getUserMappings();
               this.getSampleTypes();
               this.getGarments();
                
               this.getSampleItemTypes();

               this.getUserProfile(1); // 1 for with_tasks
            });
          
        },
        methods: {
            async completeSample(sample){
                this.working = true;
                const completedDate = new Date().toISOString();
                var formdata = {
                    completed: 1,
                    
                };

                try {
                    const response = await SampleService.completeSample(this.accessToken, sample.id, formdata);
                    console.log(response);
                    sample.completed = 1;
                    sample.completed_date = completedDate;
                } catch (error) {
                    if (error.response && error.response.status === 422) {
                        console.log("Error:" + JSON.stringify(error.response.data));
                    }
                    alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!");
                } finally {
                    this.working = false;
                }
            },
            async unCompleteSample(sample){
                this.working = true;
                if(confirm("Are you sure you want to re-open this request ? "))
                {
                    
                    var formdata = {
                        completed: 0,
                        
                    };

                    try {
                        const response = await SampleService.unCompleteSample(this.accessToken, sample.id, formdata);
                        console.log(response);
                        sample.completed = 0;
                        sample.completed_date = null;
                    } catch (error) {
                        if (error.response && error.response.status === 422) {
                            console.log("Error:" + JSON.stringify(error.response.data));
                        }
                        alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!");
                    } finally {
                        this.working = false;
                    }
                }
                else {
                    this.working = false;
                    return false;
                }
            },
            async completeArea(sample_item, area) {
                this.working=true

                var formdata = { 
                    area: area
                }; 

                SampleService.completeSampleItemArea(this.accessToken, sample_item.id, formdata)
                .then(() => {
                    this.working=false;
                    
                    sample_item[area + "_completed"] = 1
                }).catch((error) => {
                    if(error.response.status == 409)
                    {
                        alert("It looks like that area has already been completed for this item")
                        console.log("Error:" + JSON.stringify(error.response.data));
                    }
                    else {
                        alert("Something went wrong and the sample has not been updated. Please reload and try again")
                        console.log("Error:" + JSON.stringify(error.response.data));
                    }
                    this.working = false
                }); 
                
            },  
             async unCompleteArea(sample_item, area) {
                this.working=true

                var formdata = { 
                    area: area
                }; 

                SampleService.unCompleteSampleItemArea(this.accessToken, sample_item.id, formdata)
                .then(() => {
                    this.working=false;
                    
                    sample_item[area + "_completed"] = 0
                }).catch((error) => {
                    if(error.response.status == 409)
                    {
                        alert("It looks like that area has already been completed for this item")
                        console.log("Error:" + JSON.stringify(error.response.data));
                    }
                    else {
                        alert("Something went wrong and the sample has not been updated. Please reload and try again")
                        console.log("Error:" + JSON.stringify(error.response.data));
                    }
                    this.working = false
                }); 
                
            },  
            addItem() {
                this.showAddItemModal=true
                                this.garment_not_in_list = false;
                                this.new_garment_name = '';
                                this.getFabrics();  
            },
            addNote() {
                this.note_text = ''
                this.showAddNoteModal=true
                
            },
            openInstructionsModal(row) {
                this.selectedItemInstructions = row.instructions || '';
                this.selectedInstructionItemName = row.garment_id == 0 ? row.new_garment_name : row.garmentname;
                this.showInstructionsModal = true;
            },
            closeInstructionsModal() {
                this.showInstructionsModal = false;
                this.selectedItemInstructions = '';
                this.selectedInstructionItemName = '';
            },
            handleFileUpload(event) {
                this.file = event.target.files[0];
                },
                submitFile() {
                    if (!this.file) {
                        alert("Please select a file first.");
                        return;
                    }
                    this.working = true
        
                    var sample_id = this.$route.params.id;

                    let formData = new FormData();
                    formData.append("file", this.file);
                    formData.append("sample_id", sample_id);
                    formData.append("file_description", this.file_description);

                    SampleService.saveSampleAttachment(this.accessToken, formData)
                    .then(() => {
                        this.working = false
                        // Clear the file input field
                        this.$refs.fileInput.value = "";
                        this.file = null; // Reset file data
                        this.file_description = ''
                        //console.log(response)
                        this.getSample();
                    }).catch((error) => {
                    alert("Something went wrong and the order has not been updated. Please reload and try again")
                        console.log("Error:" + JSON.stringify(error.response.data));
                        this.working = false
                    });
                },
            async getGarments() {
                this.loading = true;
                UtilityService.getSimpleApiData(this.accessToken, "garments?order_by=garmentname ASC&include_hidden=" + this.include_hidden).then(
                    response => {
                        this.garments = response 
                        this.loading = false;
                    }
                    );
            },
            async getTeams() {
                UtilityService.getSimpleApiData(this.accessToken, "teams").then(
                response => this.teams = response 
                );
            },
            async getFabrics() {
                UtilityService.getSimpleApiData(this.accessToken, "fabrics").then(
                response => this.fabrics = response 
                );
            },
            async getUserMappings() {
                UtilityService.getSimpleApiData(this.accessToken, "user_mappings").then(
                    response => this.users = response 
                );
            },
            async getSampleTypes() {
                UtilityService.getSimpleApiData(this.accessToken, "sample_types").then(
                response => this.sample_types = response 
                );
            },
            async getSampleItemTypes() {
                UtilityService.getSimpleApiData(this.accessToken, "sample_item_types").then(
                response => this.sample_item_types = response 
                );
            },
            async getSample() {
                this.loading=true
                SampleService.getSample(this.accessToken, this.$route.params.id)
                .then(
                    (sample => {
                        this.$set(this, "sample", sample);
                        this.loading=false
                        this.working = false
                        this.showAddItemModal = false
                    }).bind(this)
                );
            },
            isNumber: function(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) ) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            toggleGarmentNotInList() {
                if (this.garment_not_in_list) {
                    this.garment_id = '';
                } else {
                    this.new_garment_name = '';
                }
            },
            async saveSampleItem() {
                
                this.working = true
                var formdata = { 
                    sample_id : this.sample.id,
                    sample_item_type_id: this.sample_item_type_id,
                    garment_id: this.garment_id,
                    fabric_id: this.fabric_id,
                    item_quantity : this.item_quantity,
                    item_instructions : this.item_instructions,
                    item_embroidery : this.item_embroidery,
                    item_silicon : this.item_silicon,
                    item_trims : this.item_trims,
                    item_dtf : this.item_dtf,
                    new_garment_name: this.garment_not_in_list ? this.new_garment_name : '',
                }; 

                SampleService.saveSampleItem(this.accessToken, formdata)
                .then((response) => {
                    this.getSample();
                    console.log(response)
                    
                    }).catch((error) => {
                        if(error.response.status === 422)
                        {
                            console.log("Error:" + JSON.stringify(error.response.data));
                        }
                        alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!")
                        this.working = false
                });
                
            },
            async saveSampleNote() {
                
                this.working = true
                var formdata = { 
                    sample_id : this.sample.id,
                    note_text: this.note_text,
                    return_request: this.return_request
                }; 

                SampleService.saveSampleNote(this.accessToken, formdata)
                .then((response) => {
                    this.getSample();
                    
                    this.showAddNoteModal = false
                    this.working=false

                    console.log(response)
                    
                    }).catch((error) => {
                        if(error.response.status === 422)
                        {
                            console.log("Error:" + JSON.stringify(error.response.data));
                        }
                        alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!")
                        this.working = false
                });
                
            },
            getStartDate() {
            
                var d = new Date();
                
                d.setDate(d.getDate() );
                return d.toISOString().slice(0,10);
                
            },
            async submitRequest(){
                this.working = true
                if(confirm('Are you sure you want to submit this request for production ?'))
                {
                    var sample_id = this.sample.id
                
                    SampleService.submitSample(this.accessToken, sample_id)
                    .then(() => {
                        this.working = false
                        //console.log(response)
                        this.$router.push("/samples/list-samples/mysamples");
                    }).catch((error) => {
                    alert("Something went wrong and the order has not been updated. Please reload and try again")
                        console.log("Error:" + JSON.stringify(error.response.data));
                        this.working = false
                    });
                }
                else {
                    this.working=false;
                    return false;
                }
              
            },
            async resubmitRequest(){
                this.working = true
                if(confirm('Are you sure you want to re-submit this request for production ?'))
                {
                    var sample_id = this.sample.id
                
                    SampleService.resubmitSample(this.accessToken, sample_id)
                    .then(() => {
                        this.working = false
                        //console.log(response)
                        this.$router.push("/samples/list-samples/mysamples");
                    }).catch((error) => {
                    alert("Something went wrong and the order has not been updated. Please reload and try again")
                        console.log("Error:" + JSON.stringify(error.response.data));
                        this.working = false
                    });
                }
                else {
                    this.working=false;
                    return false;
                }
              
            }
           
        },
        computed : {
            admin_user: function () {
                return this.role_allowed('R(samples_admin)') === true;
            },
            filteredGarments: function () {
            
                return this.garments.filter(garment =>
                    garment.garmentname.toLowerCase().includes(this.garmentQuery.toLowerCase())
                    );
            
            },
        }
       
    }
    </script>